export default function getDraggableItemSchema(key, component) {
  return {
    key,
    render: () => component,
  };
}
